/* Stylesheet */

.data_import_wrapper {
  height: 100%;

  .row {
    height: 100%;

    .col {
      .children_container {
        margin: 0px 4px 0px 4px;
        height: 100%;
        background: var(--ion-gradient-light);
        box-shadow: var(--ion-box-shadow);
        border-radius: 5px;
      }
    }
  }
}
